var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPowerPlatform(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_84_430"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4,
    result: "effect1_foregroundBlur_84_430"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_84_430"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_84_430"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_84_430",
    x1: 9,
    y1: 58,
    x2: 19,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#159455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FBDA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_84_430",
    x1: 24.8987,
    y1: 5.52273,
    x2: 82.9153,
    y2: 31.3167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23A794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568447,
    stopColor: "#007A84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005158"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_84_430",
    x1: 74,
    y1: 40,
    x2: 63.5,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405563,
    stopColor: "#105DA8",
    stopOpacity: 0.500243
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2170C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_84_430",
    x1: 17,
    y1: 36,
    x2: 69.5,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FD9A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196063,
    stopColor: "#47BF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713946,
    stopColor: "#009280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007A84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_84_430",
    x1: 16.5,
    y1: 37,
    x2: 28.5,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8E47C",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367474,
    stopColor: "#87D152",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58BE5A",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_84_430",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 88,
    height: 92
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2108 2H75.7297C86.7897 2 94.0145 13.5445 89.2654 23.4644L90.0002 22L76.2654 49.4696C76.2262 49.5513 76.1862 49.6329 76.1455 49.7144L74.0002 54L76.1461 49.7082C73.6052 54.79 68.4112 58 62.7297 58H39.0002L22.1995 91.6014C20.8813 94.2378 17.1191 94.2378 15.8009 91.6014L4.06542 68.1305C2.99573 65.9911 3.13282 63.6781 4.09866 61.803L17.0229 35.9545C18.2347 33.5309 20.7118 32 23.4215 32H72.9425C70.3205 29.5491 66.7837 28 62.7321 28H26.7877C24.1287 28 22.3993 25.2017 23.5884 22.8234L33.0115 3.97728C33.6174 2.76547 34.8559 2 36.2108 2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_84_430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3262 58H39L22.1993 91.6014C20.8811 94.2378 17.1189 94.2378 15.8007 91.6014L4.06525 68.1305C1.73809 63.4762 5.12256 58 10.3262 58Z",
    fill: "url(#paint0_linear_84_430)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2106 2H75.7295C86.8802 2 94.1327 13.7347 89.1459 23.7082L76.2652 49.4696C76.226 49.5513 76.1861 49.6329 76.1453 49.7144L74 54L76.2652 49.4696C81.0192 39.5494 73.7946 28 62.732 28H26.7876C24.1286 28 22.3991 25.2017 23.5883 22.8234L33.0113 3.97728C33.6172 2.76547 34.8557 2 36.2106 2Z",
    fill: "url(#paint1_linear_84_430)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2106 2H75.7295C86.8802 2 94.1327 13.7347 89.1459 23.7082L76.2366 49.5268C76.2062 49.5896 76.1753 49.6523 76.144 49.7149L75 52L76.2366 49.5268C81.0459 39.5939 73.8149 28 62.7309 28H26.7876C24.1286 28 22.3991 25.2017 23.5883 22.8234L33.0113 3.97728C33.6172 2.76547 34.8557 2 36.2106 2Z",
    fill: "url(#paint2_linear_84_430)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_84_430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.7295 58.4H10.4213C7.71219 58.4 5.23554 59.9303 4.02347 62.3531L17.0227 36.3546C18.2345 33.931 20.7116 32.4 23.4213 32.4H75.7264C81.4004 32.4 86.5887 29.1986 89.1333 24.1273L90 22.4L76.1459 50.1082C73.605 55.19 68.4111 58.4 62.7295 58.4Z",
    fill: "black",
    fillOpacity: 0.24
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_84_430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.7295 60H10.4213C7.71219 60 5.23554 61.5303 4.02347 63.9531L17.0227 37.9545C18.2345 35.5309 20.7116 34 23.4213 34H75.7264C81.4004 34 86.5887 30.7985 89.1333 25.7272L90 24L76.1459 51.7082C73.605 56.79 68.4111 60 62.7295 60Z",
    fill: "black",
    fillOpacity: 0.32
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.7295 58H10.4213C7.71219 58 5.23554 59.5303 4.02347 61.9531L17.0227 35.9545C18.2345 33.5309 20.7116 32 23.4213 32H75.7264C81.4004 32 86.5887 28.7985 89.1333 23.7272L90 22L76.1459 49.7082C73.605 54.79 68.4111 58 62.7295 58Z",
    fill: "url(#paint3_linear_84_430)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M62.7004 58H10.4598C7.75011 58 5.27299 59.5309 4.06119 61.9546L17.0612 35.9545C18.273 33.5309 20.7501 32 23.4598 32H76C81.4957 32 86.5234 28.9061 89 24L76.1107 49.7203C73.5675 54.7954 68.3771 58 62.7004 58Z",
    fill: "url(#paint4_linear_84_430)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerPlatform);
export default __webpack_public_path__ + "static/media/PowerPlatform.da5c8d862490148d7f428830c76638fb.svg";
export { ForwardRef as ReactComponent };